import { ActivationData } from '@features/auth/types';
import { IActivationService } from './activation.service.interface';

export class MockActivationService implements IActivationService {
  private mockActivationData: ActivationData = {
    // Fill with mock values as appropriate for ActivationData
    // Example:
    // userId: 'mock-user',
    // token: 'mock-token',
    token: 'mock-token',
    deviceIdentifier: 'mock-device-id',
    deviceName: 'Mock Device',
    instituteName: 'Mock Institute',
  };

  getActivationData(): ActivationData | null {
    return this.mockActivationData;
  }

  setActivationData(data: ActivationData): void {
    // No-op for mock
  }

  isActivatedSchoolDevice(): boolean {
    return true;
  }

  isActivatedHomeDevice(): boolean {
    return this.mockActivationData.isHomeDevice || false;
  }

  setPlayerGroupCode(playerGroupCode: string): void {
    // No-op for mock
  }

  getPlayerGroupCode(): string | null {
    return 'mock-group-code';
  }

  deletePlayerGroupCode(): void {
    // No-op for mock
  }

  deleteActivationData(): void {
    // No-op for mock
  }
}
